import { Component, inject } from '@angular/core';
import { CurrentService } from 'src/app/services/current.service';

/**
 * Preview de l'étape Configuration des vantaux.
 * Affiche N silhouettes neutres correspondant au nombre de vantaux sélectionné.
 */
@Component({
  selector: 'ng-casto-closet-doors-standard-preview-door-configuration',
  templateUrl: './preview-step-door-configuration.component.html',
  styleUrls: ['./preview-step-door-configuration.component.scss'],
})
export class PreviewStepDoorConfigurationComponent {
  private readonly current = inject(CurrentService);

  /** Nombre de vantaux sélectionné — détermine le nombre de silhouettes affichées. */
  protected get doorNumber() {
    return this.current.closetDoors.doorNumber;
  }
}
